import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../utils/api';

const LoginPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleTwitchLogin = async () => {
    setIsLoading(true);
    try {
      const response = await authApi.login();
      window.location.href = response.data.auth_url;
    } catch {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    const hash = window.location.hash;
    if (hash.startsWith('#token=')) {
      const token = hash.slice('#token='.length);
      try {
        const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(atob(base64));
        localStorage.setItem('authToken', token);
        localStorage.setItem('channelId', String(payload.channel_id));
        window.history.replaceState({}, '', window.location.pathname);
        navigate('/dashboard');
      } catch {
        console.error('Invalid auth token');
      }
    }
  }, [navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9f9f9' }}>
      <div style={{ width: 320, textAlign: 'center' }}>
        <h1 style={{ fontSize: 22, fontWeight: 600, color: '#111', marginBottom: 8 }}>Stream Tools</h1>
        <button
          onClick={handleTwitchLogin}
          disabled={isLoading}
          style={{
            width: '100%',
            padding: '10px 0',
            background: '#6441a5',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            fontSize: 14,
            fontWeight: 500,
            cursor: isLoading ? 'not-allowed' : 'pointer',
            opacity: isLoading ? 0.7 : 1,
          }}
        >
          {isLoading ? 'Connecting…' : 'Connect with Twitch'}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
